import { VideoOverlayNamedPayload, VideoOverlayPayload } from '@/scripts/store/modules/video/mutations/manageVideoPlayerOverlays/createOverlayHelper';
import { VideoOverlayPriority, VideoOverlayType } from '@/scripts/store/modules/video/state/VideoOverlay';

export const extendOverlay = (extendee: VideoOverlayPayload, overlay: Partial<VideoOverlayPayload>): VideoOverlayPayload => ({
  ...extendee,
  ...overlay,
});

const extractComponentFromImport = async<T>(promise: Promise<{ default: T }>): Promise<T> => {
  const { default: component } = await promise;
  return component;
};

export const VideoDownloadOverlay: VideoOverlayNamedPayload = {
  name: 'VideoDownloadOverlay',
  priority: VideoOverlayPriority.UserInteraction,
  type: VideoOverlayType.Dismissable,
  component: () => extractComponentFromImport(
    import('./presenters/views/VideoDownloadOverlay.ts.vue'),
  ),
};
